import { Component, OnInit, Inject, Input } from '@angular/core';
import {
  Router,
  NavigationStart,
  RouterLink,
  RouterLinkActive,
} from '@angular/router';
import { environment } from 'src/environments/environment';
// Services
import { AuthenticationService } from 'src/app/services/auth/authentication.service';
import { SharedService } from '../../services/api/message.service';

// models
import { SchoolData } from 'src/app/models/schoolUser';
import { CommonService } from 'src/app/services/api/common.service';
import { Subscription } from 'rxjs';
// import { Intercom } from '@supy-io/ngx-intercom';
import Intercom from '@intercom/messenger-js-sdk';
import { MixpanelService } from 'src/app/mixpanel.service';
import { SwichBackToPythonComponent } from '../swich-back-to-python/swich-back-to-python.component';
import { NgClass, NgIf } from '@angular/common';
import { CommonAnnouncementComponent } from 'src/app/pages/common/common-announcement/common-announcement.component';
import { NgxUiLoaderService } from 'ngx-ui-loader'; // Import NgxUiLoaderService
import { ToastrService } from 'ngx-toastr';
import { BrazeService } from 'src/app/braze.service';
import { ba } from '@fullcalendar/core/internal-common';
import { DirectivesModule } from 'src/app/directives.module';
declare var $: any;
declare var Canny: any; // Add this at the top of your TS file
import { PermissionService } from 'src/app/services/auth/permissions.service';
import { PERMISSIONS } from 'src/app/config/permissions.constants';

@Component({
  selector: 'app-producer-header',
  templateUrl: './producer-header.component.html',
  styleUrls: ['./producer-header.component.scss'],

  standalone: true,
  imports: [
    NgClass,
    NgIf,
    RouterLink,
    RouterLinkActive,
    CommonAnnouncementComponent,
    DirectivesModule
  ],
})
export class ProducerHeaderComponent implements OnInit {
  public schoolProps!: SchoolData;
  plan: any;
  title: any;
  sub!: Subscription;
  languages = [];
  schoolLogo: any;
  current_plan: any;
  activateScript: boolean = false;
  from_page_cookie: any;
  header: any;
  hideHeader: boolean = false;
  currentUrl: any;
  @Input() announcementData = ''; // Your dynamic message
  loggedIn: boolean = false;
  hideSwitchAction: boolean = false;
  PERMISSIONS = PERMISSIONS;

  constructor(
    private authService: AuthenticationService,
    @Inject(Router) private router: Router,
    private commonService: CommonService,
    private sharedService: SharedService,
    // public intercom: Intercom,
    private mixpanelService: MixpanelService,
    private ngxService: NgxUiLoaderService,
    private toastr: ToastrService,
    private brazeService: BrazeService,
    public permissionService: PermissionService
  ) { }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.routerChangeMethod(event.url);
      }
    });

    if (window.location.hostname == 'booking.classcover.com.au') {
      this.activateScript = true;
    }
    this.from_page_cookie =
      document.cookie.match('(^|;)\\s*' + 'from' + '\\s*=\\s*([^;]+)')?.pop() ||
      '';
    this.loadUser();
    window.addEventListener('user-switched', () => {
      this.loadUser();
    });
    this.schoolLogo = localStorage.getItem('schoolLogo');
    if (
      localStorage.getItem('current_plan') == '' ||
      localStorage.getItem('current_plan') == null
    ) {
      this.plan = '';
    } else {
      this.plan = localStorage.getItem('current_plan') + ' plan';
    }
    this.mixpanelService.init(
      this.schoolProps.mixpanel_data.user_id.toString(),
      this.schoolProps.mixpanel_data.mixpanel_app_id
    );
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.routerChangeMethod(event.url);
      }
    });
    // if (
    //   this.schoolProps.properties.booking_school &&
    //   !this.schoolProps.properties.job_only_school
    // ) {
    $('head').append(
      '<script src="//embed.typeform.com/next/embed.js"></script><div data-tf-live="01J1Y5S4E6D3S23C76ST2V29VP"></div>'
    );
    // }
    this.currentUrl = this.router.url.split('?');

    if (this.currentUrl[0] == '/school/onboarding-classcover-overview') {
      this.hideHeader = true;
    } else if (this.currentUrl[0] == '/school/school-onboarding') {
      this.hideHeader = true;
    } else if (this.currentUrl[0] == '/school/school-onboarding-findNew') {
      this.hideHeader = true;
    } else if (this.currentUrl[0] == '/school/onboarding-profile') {
      this.hideHeader = true;
    } else if (this.currentUrl[0] == '/school/bookings/booking-request') {
      console.log(this.currentUrl[0]);
      this.hideHeader = false;
    } else {
      this.hideHeader = false;
    }
    Canny('initChangelog', {
      appID: '68de4a8304887f1960a022d7',
      labelIDs: ['693b6be520a022910065c07d'], // Schools

      position: 'bottom',
      align: 'right',
      theme: 'light',
    });
    // window.onload = () => {
    this.intercomValues();
    // };

    this.mixpanelService.schoolUserLoad(this.schoolProps);
    this.brazeService.initializeBraze(this.schoolProps);
  }
  intercomValues() {
    Intercom({
      app_id: this.schoolProps.mixpanel_data.app_id.toString(),
      region: 'ap',
      apiBase: 'https://api.au.intercom.io',
      name: this.schoolProps.mixpanel_data.name,
      user_id: this.schoolProps.mixpanel_data.user_id.toString(),
      user_hash: this.schoolProps.mixpanel_data.user_hash,
      school_name: this.schoolProps.mixpanel_data.school_name, // Full name
      group_name: this.schoolProps.mixpanel_data.group_name,
      email: this.schoolProps.mixpanel_data.email, // Email address
      created_at: this.schoolProps.mixpanel_data.created_at, // Signup date as a Unix timestamp,
      user_type: this.schoolProps.mixpanel_data.school_type,
      state: this.schoolProps.mixpanel_data.state,
      city: this.schoolProps.mixpanel_data.city,
      postal_code: this.schoolProps.mixpanel_data.postal_code,
      enabled: this.schoolProps.mixpanel_data.enabled,
      school_id: this.schoolProps.mixpanel_data.school_id,
      company: {
        id: this.schoolProps.mixpanel_data.school_id,
        name: this.schoolProps.mixpanel_data.school_name,
        subscription_type: this.schoolProps.mixpanel_data.subscription_type,
        school_level: this.schoolProps.mixpanel_data.school_level,
        school_type: this.schoolProps.mixpanel_data.school_type,
        low_year: this.schoolProps.mixpanel_data.low_year,
        high_year: this.schoolProps.mixpanel_data.high_year,
        enrolment_size: this.schoolProps.mixpanel_data.enrolment_size,
        school_summary: this.schoolProps.mixpanel_data.school_summary,
        created_at: this.schoolProps.mixpanel_data.created_at,
      },
      school_signup_date: this.schoolProps.mixpanel_data.school_signup_date,
      customer_id: this.schoolProps.mixpanel_data.user_id,
      school_user_role: this.schoolProps.mixpanel_data.school_user_role,
      school_booking_request:
        this.schoolProps.mixpanel_data.school_booking_request,
      school_manual_bookings:
        this.schoolProps.mixpanel_data.school_booking_request,
      school_teacher_count: this.schoolProps.mixpanel_data.school_teacher_count,
      is_qld_user: this.schoolProps.properties.is_qld_user
    } as any);
  }
  ngAfterViewInit() {
    // Canny('render', {
    //   boardToken: 'c4b28b23-e58f-4755-7ab5-64cf6214d01b',
    //   basePath: null, // See step 2
    //   ssoToken: null, // See step 3
    //   theme: 'light', // options: light [default], dark, auto
    // });
    Canny('renderChangelog', {
      labelIDs: ['696f1c2b0f343ed4ebeb7351'], // Schools
      theme: 'light'
    });
    // Canny('initChangelog', {
    //   appID: '68de4a8304887f1960a022d7',
    //   position: 'bottom',
    //   align: 'right',
    //   theme: 'light', // options: light [default], dark, auto
    // });
  }
  ngAfterContentInit() {
    this.sub = this.sharedService.send_data.subscribe((data) => {
      this.plan = data;
    });
    this.sub = this.sharedService.school_logo.subscribe((data) => {
      this.schoolLogo = data;
    });
    this.header = this.sharedService.header.subscribe((data) => {
      this.hideHeader = data;
    });
    this.current_plan = this.sharedService.current_plan.subscribe((data) => {
      localStorage.setItem('current_plan', data);
      if (
        localStorage.getItem('current_plan') == '' ||
        localStorage.getItem('current_plan') == null
      ) {
        this.plan = '';
      } else {
        this.plan = localStorage.getItem('current_plan') + ' plan';
      }
    });

    this.sub = this.sharedService.announcement.subscribe((data) => {
      this.announcementData = data;
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.currentUrl = event.url.split('?');
      }
    });

    if (this.currentUrl[0] == '/school/onboarding-classcover-overview') {
      this.hideHeader = true;
    } else if (this.currentUrl[0] == '/school/school-onboarding') {
      this.hideHeader = true;
    } else if (this.currentUrl[0] == '/school/school-onboarding-findNew') {
      this.hideHeader = true;
    } else if (this.currentUrl[0] == '/school/onboarding-profile') {
      this.hideHeader = true;
    } else if (this.currentUrl[0] == '/school/bookings/booking-request') {
      console.log(this.currentUrl[0]);
      this.hideHeader = false;
    } else {
      this.hideHeader = false;
    }
  }

  routerChangeMethod(url: any) {
    if (window.location.hostname == 'booking.classcover.com.au') {
      this.activateScript = true;
    }
    this.mixpanelService.init(
      this.schoolProps.mixpanel_data.user_id.toString(),
      this.schoolProps.mixpanel_data.mixpanel_app_id
    );

    this.currentUrl = url.split('?');

    if (this.currentUrl[0] == '/school/onboarding-classcover-overview') {
      this.hideHeader = true;
    } else if (this.currentUrl[0] == '/school/school-onboarding') {
      this.hideHeader = true;
    } else if (this.currentUrl[0] == '/school/school-onboarding-findNew') {
      this.hideHeader = true;
    } else if (this.currentUrl[0] == '/school/onboarding-profile') {
      this.hideHeader = true;
    } else {
      this.hideHeader = false;
    }
  }
  logout() {
    this.ngxService.start();
    if (localStorage.getItem('bookingSchool') == 'true') {
      this.authService.loggedOut();
      // if (this.router) {
      //   this.router.ngOnDestroy();
      // }
    } else {
      this.authService.loggedOut();
      // if (this.router) {
      //   this.router.ngOnDestroy();
      // }
    }
  }
  backToAdmin() {
    this.authService.loggedOut();
    // if (this.router) {
    //   this.router.ngOnDestroy();
    // }
    window.open(environment.backToAdmin, '_self');
  }
  backToCoOrdinator() {
    this.authService.loggedOutCo();
    if (this.router) {
      this.router.ngOnDestroy();
    }
  }
  backToGroup() {
    this.authService.loggedOut();
    if (this.router) {
      this.router.ngOnDestroy();
    }
    window.open(environment.backToGroup, '_self');
  }

  backToFromCoGroup(rta_user: any) {
    localStorage.removeItem('switch_user_id');
    this.ngxService.start();
    let user_id =
      document.cookie
        .match('(^|;)\\s*' + 'redirect_user' + '\\s*=\\s*([^;]+)')
        ?.pop() || '';
    var data = {
      user_id: user_id,
      back_to: '1',
    };
    this.commonService.loginToAngular(data).subscribe({
      next: (res: any) => {
        this.loggedIn = true;
        document.cookie =
          'from=; path=/; domain=.' +
          environment.cookiesDomain +
          '; expires=' +
          new Date(0).toUTCString();
        document.cookie =
          'access_token=' +
          res.access_token +
          ';domain=.' +
          environment.cookiesDomain +
          ';path=/';
        document.cookie =
          'refresh_token=' +
          res.refresh_token +
          ';domain=.' +
          environment.cookiesDomain +
          ';path=/';
        document.cookie =
          'redirect_user=' +
          res.user_id +
          ';domain=.' +
          environment.cookiesDomain +
          ';path=/';
        window.open('/login', '_self');
        this.ngxService.stop();
      },
      error: (err: any) => {
        this.toastr.error(err.message || 'Failed to login to school');
        this.ngxService.stop();
        console.log(err);
      },
    });
  }

  shouldShowHeader(): boolean {
    const hostname = window.location.hostname;
    const href = window.location.href;
    const isQldBeta = hostname === 'qld-beta.classcover.com.au';
    // Hide header on qld-beta domain
    if (isQldBeta) {
      return false;
    }
    return !this.hideSwitchAction;
  }
  navigateToBooking() {
    this.router.navigate(['/school/bookings/booking-request']);
  }
  switchBack() {
    this.ngxService.start();
    this.commonService.switchBackToPython().subscribe({
      next: (res: any) => {
        this.ngxService.stop();
        if (res) {
          window.location.replace(environment.apiUrl);
        } else {
          console.log('error in the response', res);
        }
      },
      error: (err: any) => {
        console.log(err);
        this.toastr.error(err.message);
        this.ngxService.stop();
      },
    });
  }
  openChangelog() {
    Canny('closeChangelog');
    Canny('renderChangelog', {
      basePath: '/school/changelog',
      labels: '693b6be520a022910065c07d', // Schools
      theme: 'light'
    });
  }

  loadUser() {
    this.schoolProps = JSON.parse(localStorage.getItem('userData') || '{}');
  }
}
